export default __webpack_public_path__ + "static/media/103.2596973d.png";